import { type ReactNode } from 'react';
import cx from 'clsx';
import { MainLayout } from '../main/main-layout';
import styles from './registration-layout.module.css';

interface RegistrationLayoutProps {
  children: ReactNode;
  aside?: ReactNode;
}

export function RegistrationLayout({ children, aside }: RegistrationLayoutProps): ReactNode {
  return (
    <div className={cx(styles.wrapper, !aside && styles.mainOnly)}>
      <MainLayout>
        <section className={styles.mainInner}>{children}</section>
      </MainLayout>
      {aside ? (
        <aside className={styles.asideWrapper} data-video-animation-test>
          {aside}
        </aside>
      ) : null}
    </div>
  );
}
